import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const WeeklySummaryCard = ({ summary, loading, formatNumber }) => {
  const summaryItems = [
    {
      label: 'New leads',
      key: 'newLeads',
      description: 'Total number of conversations initiated by customers.',
    },
    {
      label: 'Marketing delivered',
      key: 'marketing',
      description:
        'Total messages in Marketing category delivered to recipients.',
    },
    {
      label: 'Marketing lite delivered',
      key: 'marketingLite',
      description:
        'Total messages in Marketing Lite category delivered to recipients.',
    },
    {
      label: 'Utility delivered',
      key: 'utility',
      description:
        'Total messages in Utility category delivered to recipients.',
    },
    {
      label: 'Authentication delivered',
      key: 'authentication',
      description:
        'Total messages in Authentication category delivered to recipients.',
    },
  ];

  const maxValue =
    loading || !summary
      ? 0
      : Math.max(...summaryItems.map((item) => Number(summary[item.key] || 0)), 1);

  return (
    <div className="col-span-12 lg:col-span-5 bg-[var(--surface)] rounded-2xl p-6 shadow-[0px_20px_50px_-32px_rgba(15,23,42,0.35)] border border-[var(--surface-border)]">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-[18px] font-semibold text-[var(--textBlack)]">Weekly summary</p>
          <p className="text-sm text-[var(--font-600)]">Last 7 days overview</p>
        </div>
        {/* <span className="text-xs px-3 py-1 rounded-full bg-[var(--surface-muted)] border border-[var(--surface-border)]">
          Refreshed hourly
        </span> */}
      </div>

      <div className="mt-6 flex flex-col gap-3">
        {loading
          ? [...Array(5)].map((_, index) => (
              <div
                key={`weekly-skeleton-${index}`}
                className="h-12 rounded-lg bg-[#F2F4F7] animate-pulse"
              />
            ))
          : summaryItems.map((item, idx) => {
              const value = Number(summary[item.key] || 0);
              const percent = maxValue ? Math.min(100, (value / maxValue) * 100) : 0;
              const accent = idx === 0 ? 'var(--accent-2)' : 'var(--accent)';
              return (
                <div
                  key={item.key}
                  className="flex items-center gap-3 border border-[var(--surface-border)] rounded-xl px-3 py-3 bg-[var(--surface-muted)]"
                >
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                      <span className="text-sm text-[var(--font-600)]">
                        {item.label}
                      </span>
                      <Tooltip title={item.description} placement="top">
                        <InfoCircleOutlined className="text-[var(--font-600)] text-xs cursor-help hover:text-[#6940F2] transition-colors" />
                      </Tooltip>
                    </div>
                    <div className="h-2 mt-2 rounded-full bg-white overflow-hidden border border-[var(--surface-border)]">
                      <div
                        className="h-full rounded-full"
                        style={{
                          width: `${percent.toFixed(0)}%`,
                          background: accent,
                          transition: 'width 250ms ease-out',
                        }}
                      />
                    </div>
                  </div>
                  <span className="font16px-600 text-[var(--textBlack)]">
                    {formatNumber(value)}
                  </span>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default WeeklySummaryCard;
